import { Notification } from './notification';

export const NOTIFICATIONS_PAGE_SIZE = 25;

export type NotificationsPage = {
  notifications: Array<Notification>;
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
};

export abstract class NotificationRepository {
  abstract list(page: number, pageSize: number): Promise<NotificationsPage>;

  abstract markRead(id: string): Promise<void>;

  abstract markAllRead(): Promise<void>;

  abstract unreadCount(): Promise<number>;
}
